var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.193922 0.20361C0.452485 -0.0678706 0.875102 -0.0678706 1.13545 0.20361L6 5.30746L10.861 0.20361C11.1195 -0.0678706 11.5422 -0.0678706 11.8061 0.20361C12.0646 0.475091 12.0646 0.918823 11.8061 1.19592L6.47255 6.79592C6.34594 6.92885 6.17832 7 6 7C5.82168 7 5.65406 6.92885 5.52745 6.79592L0.193922 1.19592C-0.0646408 0.920695 -0.0646408 0.475091 0.193922 0.20361Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBottom);
export default __webpack_public_path__ + "static/media/arrow-bottom.7de9dfad6610b384c0d7673965d39a28.svg";
export { ForwardRef as ReactComponent };